appConfig.registerModule('translations');
